import httpClient, { httpFormDataClient } from "./httpClient";

const prefix = "/attendance-wildcards";

export async function fetchWildcardHistory(partnerId) {
  return (await httpClient.get(`${prefix}/history/${partnerId}`)).data;
}

export async function fetchWildcardCodes(partnerId) {
  return (await httpClient.get(`${prefix}/check-count/${partnerId}`)).data;
}

export async function generateNewCode(data) {
  return (await httpClient.post(`${prefix}`, data)).data;
}

export async function updateRemainingWildcards(partnerId, newCount) {
  return (
    await httpClient.patch(
      `${prefix}/update-remaining-wildcards/${partnerId}`,
      {
        newCount,
      }
    )
  ).data;
}

export async function fetchAssistanceByCode(code) {
  return (await httpClient.get(`${prefix}/assistance/${code}`)).data;
}
export async function fetchAssistanceByID(id) {
  return (await httpClient.get(`${prefix}/assistance-id/${id}`)).data;
}
export async function fetchAssistanceByTwoID(id, id2) {
  return (await httpClient.get(`${prefix}/assistance-2/${id}/${id2}`)).data;
}

//AQUI LA FUNCION DEL PATHCH PARA SUBIR LAS ASSISTENCE
export async function registerAssistanceCheckByCode(formData) {
  try {
    const response = await httpFormDataClient.post(
      `/assistance-check/register-assistance-code`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Error registrando asistencia", error);
    throw error;
  }
}

export async function fetchRemainingWildcardsPartner(partnerId) {
  return (await httpClient.get(`${prefix}/remainings/${partnerId}`)).data;
}
export async function fetchInfoCode(partnerId) {
  return (await httpClient.get(`${prefix}/info-check/${partnerId}`)).data;
}